import { THUMBNAIL_HEIGHT, THUMBNAIL_WIDTH } from '../constants/size';

export const windowSize = {
  width: THUMBNAIL_WIDTH,
  height: THUMBNAIL_HEIGHT,
};

export const imageSize = {
  width: THUMBNAIL_WIDTH,
  height: THUMBNAIL_HEIGHT,
};
